(function () {
    "use strict";

    angular.module("app").directive("markOptional", MarkOptionalDirective);

    MarkOptionalDirective.$inject = ["$filter"];
    function MarkOptionalDirective($filter) {
        return {
            priority: 1,
            restrict: "A",
            link: function (_scope, elm) {
                elm.append(` <small>(${$filter("habilTranslation")("Optional")})</small>`);
            }
        };
    }
})();
